var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{attrs:{"options":_vm.typeList,"load-data":_vm.loadData,"placeholder":"请选择动物类型","change-on-select":"","allowClear":_vm.clearble},on:{"change":_vm.onChange},model:{value:(_vm.typeArr),callback:function ($$v) {_vm.typeArr=$$v},expression:"typeArr"}})
}
var staticRenderFns = []

export { render, staticRenderFns }